import {
  GET_COMPANY_FINANCES_SUCCESS,
  GET_COMPANY_FINANCES_FAILURE,
  UPDATE_COMPANY_BALANCE_SUCCESS,
  PAY_WITH_BALANCE_SUCCESS,
  PAY_WITH_BALANCE_FAILURE
} from '../constants';

const initState = {
  currentBalance: null,
  loadingFinancials: false
};

const financesReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_COMPANY_FINANCES_SUCCESS:
      return {
        ...action.payload,
        loadingFinancials: false
      };
    case GET_COMPANY_FINANCES_FAILURE:
      return {
        ...state,
        loadingFinancials: false
      };
    case UPDATE_COMPANY_BALANCE_SUCCESS:
      const stateBalanceHistory = state.balanceHistory;
      return {
        currentBalance: action.payload.currentBalance,
        balanceHistory: [
          action.payload.newCurrentBalanceHistoryRecord,
          ...stateBalanceHistory
        ]
      };
    case PAY_WITH_BALANCE_SUCCESS:
      const balanceHistoryState = state.balanceHistory;
      return {
        currentBalance: action.payload.currentBalance,
        balanceHistory: [
          action.payload.newCurrentBalanceHistoryRecord,
          ...balanceHistoryState
        ]
      };
    default:
      return state;
  }
};

export default financesReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/financesReducer.js